/* eslint-disable no-console */
/* eslint-disable react/prop-types */
import React from 'react'
import { Form } from 'antd'
import { useController, useFormContext } from 'react-hook-form'
import styled from 'styled-components'
import { CKEditor } from '@ckeditor/ckeditor5-react'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'

import { CKUploadAdapter } from 'Adapters'

const WrapperFormItem = styled(Form.Item)`
  height: max-content;
  width: 100%;
  margin-bottom: 10px;

  .ant-input {
    min-height: 38px;
    border-radius: 4px;
  }

  .ant-form-item-label {
    font-size: 14px;
    overflow: unset;
    white-space: unset;
    .ant-form-item-no-colon {
      height: 100%;
    }
  }

  .ant-form-item-children-icon {
    display: none;
  }
  .ck.ck-editor {
    overflow: hidden;
  }
  .ck-editor__top{
    z-index: calc(var(--ck-z-modal) + 1);
  }
  .ck.ck-editor__main>.ck-editor__editable{
    padding: 20px;
  }
`

const WrapperLabel = styled.div`
  width: 100%;
  font-size: 13px;
`

const FormEditor = ({
  setIsLoadingImageSuccess,
  label,
  name,
  rules,
  defaultValue = '',
  wrapperProps,
  ...rest
}) => {
  const { control } = useFormContext()
  const {
    field: { onChange, value },
    fieldState: { error }
  } = useController({ name, control, rules, defaultValue })

  return (
    <WrapperFormItem
      {...wrapperProps}
      label={label && <WrapperLabel>{label}</WrapperLabel>}
      help={error?.message}
      validateStatus={error ? 'error' : ''}
    >
      <CKEditor
        {...rest}
        editor={ClassicEditor}
        data={value}
        config={{
          toolbar: {
            items: [
              'heading',
              '|',
              'bold',
              'italic',
              'link',
              'bulletedList',
              'numberedList',
              '|',
              'fontFamily',
              'fontSize',
              'fontColor',
              'fontBackgroundColor',
              '|',
              //   'outdent',
              //   'indent',
              '|',
              'uploadImage',
              'blockQuote',
              //   'insertTable',
              //   'mediaEmbed',
              'undo',
              'redo'
            ]
          }
        }}
        onReady={(editor) => {
          // You can store the "editor" and use when it is needed.
          if (editor) {
            editor.editing.view.change((writer) => {
              writer.setStyle(
                'height',
                'calc(100vh - 485px)',
                editor.editing.view.document.getRoot()
              )
            })
            // eslint-disable-next-line no-underscore-dangle
            const body = editor.ui.view.body._bodyCollectionContainer
            body.remove()
            editor.ui.view.element.querySelector('.ck.ck-editor__main').appendChild(body)

            editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
              setIsLoadingImageSuccess(false)
              loader.on('change:uploadResponse', (evt, nameEvent, val) => {
                if (val || val === undefined) {
                  setIsLoadingImageSuccess(true)
                }
              })
              return new CKUploadAdapter(loader)
            }
          }
        }}
        onChange={(event, editor) => {
          const data = editor.getData()
          onChange(data)
        }}
      />
    </WrapperFormItem>
  )
}

export default FormEditor
